module.exports = __webpack_public_path__ + "static/media/dropoff_inactive.68b10d9a.svg";